import { createContext, type ReactNode, useContext, useMemo } from 'react'

interface IAttentionCardPartner {
  /** The partner an opened status was drilled down to, where it was opened for one. */
  partnerId?: string
  partnerName?: string
}

const AttentionCardPartnerContext = createContext<IAttentionCardPartner>({})

interface IAttentionCardPartnerProviderProps extends IAttentionCardPartner {
  children: ReactNode
}

/**
 * Who the opened card stands for.
 *
 * The card's corner offers the way to that partner's own plan page beside what the status asks
 * for, and the corner is filled by whichever section the status opened. The partner reaches it
 * through the context rather than through nine section props for one link.
 */
export const AttentionCardPartnerProvider = ({
  partnerId,
  partnerName,
  children,
}: IAttentionCardPartnerProviderProps) => {
  const value = useMemo(() => ({ partnerId, partnerName }), [partnerId, partnerName])

  return (
    <AttentionCardPartnerContext.Provider value={value}>
      {children}
    </AttentionCardPartnerContext.Provider>
  )
}

AttentionCardPartnerProvider.displayName = 'AttentionCardPartnerProvider'

/** The card's partner; empty in the single-partner cockpit, which is already on that partner. */
export const useAttentionCardPartner = () => useContext(AttentionCardPartnerContext)
